import {
  useInfiniteQuery,
  type UseInfiniteQueryOptions,
} from '@tanstack/react-query'

import { SelectOptionModel } from '@/domain/model/select'
import { QUERIES } from '@/enums/queries'

type FetchOptionsType = (
  params?: Record<string, string | number | undefined>
) => Promise<SelectOptionModel[]>

type optionsType = Omit<
  UseInfiniteQueryOptions<
    SelectOptionModel[],
    Error,
    SelectOptionModel[],
    SelectOptionModel[],
    string[]
  >,
  'queryKey' | 'queryFn'
>

export const useLoadAsyncSelect = <
  T extends Record<string, string | number | undefined>,
>(
  fetchOptions: FetchOptionsType,
  key: string[],
  searchValue: T | undefined,
  options?: optionsType
) =>
  useInfiniteQuery({
    queryKey: [
      QUERIES.ASYNC_SELECT,
      ...key,
      ...(searchValue ? Object.values(searchValue) : []),
    ] as string[],
    queryFn: async ({ pageParam }) =>
      await fetchOptions({ ...searchValue, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length ? allPages.length + 1 : undefined
    },
    ...options,
  })
